export default __webpack_public_path__ + "static/media/rewards1.78f75ff9.svg";